module.exports = __webpack_public_path__ + "static/media/tapberry_gameplay_sound.04cc4ccf.mp3";